import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../ThemeContext';

import { Wrapper, Box, Item } from './ProfileManageAsideTabs.style';

const ProfileManageAsideTabs = ({
  tabs = [],
  currentTab = '',
  handleChangeTab = () => {},
}) => {
  const theme = useTheme();

  return (
    <>
      {tabs && tabs.length > 0 ? (
        <Wrapper>
          <Box theme={theme.profileManageAsideTabs.box}>
            {tabs.map((tab, key) => (
              <Item
                theme={theme.profileManageAsideTabs.item}
                key={key}
                selected={tab.key === currentTab}
                onClick={() => {
                  handleChangeTab(tab.key);
                }}
              >
                {tab.name}
              </Item>
            ))}
          </Box>
        </Wrapper>
      ) : (
        ''
      )}
    </>
  );
};

ProfileManageAsideTabs.propTypes = {
  tabs: PropTypes.array,
  currentTab: PropTypes.string,
  handleChangeTab: PropTypes.func,
};

export default ProfileManageAsideTabs;
